import Cookies from "universal-cookie";
const cookies = new Cookies();

import type { AnyType } from "../interfaces";

interface ICookieOptions {
  path: string,  //cookie path, use / as the path if you want your cookie to be accessible on all pages
  expires: Date, // absolute expiration date for the cookie
  maxAge: number, // relative max age of the cookie from when the client receives it in seconds
  domain: string, // domain for the cookie (sub.domain.com or .allsubdomains.com)
  secure: boolean, // Is only accessible through HTTPS?
  httpOnly: boolean, // Is only the server can access the cookie? Note: You cannot get or set httpOnly cookies from the browser, only the server.
  sameSite: boolean|"none"|"lax"|"strict", // Strict or Lax enforcement
  partitioned: boolean // Indicates that the cookie should be stored using partitioned storage
}

export function setCookie(name: string, value: AnyType, options?: ICookieOptions): void {
  cookies.set(name, value, {
    path: "/",
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30), // 30 days,
    ...(options ?? {})
  });
}

export function getCookie(name: string, options?: ICookieOptions): AnyType {
  return cookies.get(name, options);
}

export function deleteCookie(name: string, options?: ICookieOptions): void {
  cookies.remove(name, options);
}
